module.exports = __webpack_public_path__ + "static/media/dashcoin.0d52889d.svg";